import React, { useContext } from 'react';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import CourseOfferingSection from '../CourseOfferingSection';
import ToolsSection from '../ToolsSection';
import MentorCompanyCard from '../MentorCompanySection';

const OfferingsSection = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const {
    courseOffering,
    masterTools,
    mentorsCompanies,
    enableCourseOffering,
    enableMasterTools,
    enableExpertCompany,
  } = courseDetails?.courseMetaDetails || {};
  return (
    <div>
      {((enableExpertCompany && mentorsCompanies && mentorsCompanies?.length > 0) ||
        (enableCourseOffering && courseOffering && courseOffering?.length > 0) ||
        (enableMasterTools && masterTools && masterTools?.length > 0)) && (
        <section id="offerings" data-title="Offerings">
          {enableCourseOffering && courseOffering && courseOffering?.length > 0 && (
            <CourseOfferingSection />
          )}
          {enableMasterTools && masterTools && masterTools?.length > 0 && <ToolsSection />}
          {enableExpertCompany && mentorsCompanies && mentorsCompanies?.length > 0 && (
            <MentorCompanyCard />
          )}
        </section>
      )}
    </div>
  );
};

export default OfferingsSection;
